/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const ItemLookupInvalidInputTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.ItemLookupInvalidInput';
export const ItemLookupInvalidInputDiscriminant = 'ItemLookupInvalidInput';
export const ItemLookupInvalidInputDiscriminantKey = '@type';
export const ItemLookupNotFoundTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.ItemLookupNotFound';
export const ItemLookupNotFoundDiscriminant = 'ItemLookupNotFound';
export const ItemLookupNotFoundDiscriminantKey = '@type';
export const ItemLookupResultDiscriminantKey = '@type';
export const ItemLookupSuccessTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.ItemLookupSuccess';
export const ItemLookupSuccessDiscriminant = 'ItemLookupSuccess';
export const ItemLookupSuccessDiscriminantKey = '@type';
export const LoginVerifyErrorInternalResponseTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.LoginVerifyErrorInternalResponse';
export const LoginVerifyErrorInternalResponseDiscriminant = 'LoginVerifyErrorInternalResponse';
export const LoginVerifyErrorInternalResponseDiscriminantKey = '@type';
export const LoginVerifyErrorUnauthenticatedResponseTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.LoginVerifyErrorUnauthenticatedResponse';
export const LoginVerifyErrorUnauthenticatedResponseDiscriminant = 'LoginVerifyErrorUnauthenticatedResponse';
export const LoginVerifyErrorUnauthenticatedResponseDiscriminantKey = '@type';
export const LoginVerifyResponseDiscriminantKey = '@type';
export const LoginVerifySuccessResponseTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.LoginVerifySuccessResponse';
export const LoginVerifySuccessResponseDiscriminant = 'LoginVerifySuccessResponse';
export const LoginVerifySuccessResponseDiscriminantKey = '@type';
export const PlatformErrorDiscriminantKey = '@type';
export const PlatformFailureTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.PlatformFailure';
export const PlatformFailureDiscriminant = 'PlatformFailure';
export const PlatformFailureDiscriminantKey = '@type';
export const UserCheckForbiddenTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.UserCheckForbidden';
export const UserCheckForbiddenDiscriminant = 'UserCheckForbidden';
export const UserCheckForbiddenDiscriminantKey = '@type';
export const placeholderMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'placeholderMethod',
  auth: 'external',
  fingerprint: 'ycAIvrze_8cgOfvOGN1AGs9i0kjEFy8C',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const loginVerifyAnnotatedRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'loginVerifyAnnotated',
  auth: 'external',
  fingerprint: 'P2bWirt3wN1K9x1I5trC6EWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const loginVerifyRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'loginVerify',
  auth: 'external',
  fingerprint: 'P2bWirt3wN3KG8U34dQOvUWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const authenticatedPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'authenticatedPortalMethod',
  auth: 'external',
  fingerprint: 'elzL7KmqQIYgOfvOGN1AGkWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dynamicCompanyFetchPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'dynamicCompanyFetchPortalMethod',
  auth: 'external',
  fingerprint: 'elzL7KmqQIb4yhPUZhxSNFcgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dynamicProjectFetchPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'dynamicProjectFetchPortalMethod',
  auth: 'external',
  fingerprint: 'elzL7KmqQIbVX2m61RMQKlcgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dynamicProjectsFetchPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'dynamicProjectsFetchPortalMethod',
  auth: 'external',
  fingerprint: 'elzL7KmqQIaae11wiJzYcEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePreferredLanguageRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'updatePreferredLanguage',
  auth: 'external',
  fingerprint: '95Ni4KYr9JPEl0ZEms6HPUWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCoursesRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getCourses',
  auth: 'external',
  fingerprint: 'elzL7KmqQIbwpRnEkDxw60WCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCourseDetailRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getCourseDetail',
  auth: 'external',
  fingerprint: 'elzL7KmqQIbMPSSNR7pa8FcgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLessonContentRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getLessonContent',
  auth: 'external',
  fingerprint: 'elzL7KmqQIYqiaq3xbP6X1cgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMyLearningRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getMyLearning',
  auth: 'external',
  fingerprint: 'elzL7KmqQIa7RrQ9I0wJikWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const lookupItemRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'lookupItem',
  auth: 'external',
  fingerprint: '1zKFaYCfVzyc6sR-8JTbBZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const slowTestMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'slowTestMethod',
  auth: 'external',
  fingerprint: 'ycAIvrze_8cgOfvOGN1AGpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};